const pagesTitleCat: Array<string> = [
    'Datos personales',
    'Detalles del vehículo',
    'Detalles de tu oferta',
];

const pagesSubTitleCat: Array<string> = [
    '¡Queremos conocerte! Ingresá los siguientes datos, según tu documento de identidad',
    'Ingresa los siguientes campos de acuerdo a la documentación de tu vehículo',
    'Te presentamos las coberturas y prima de tu oferta de Auto Seguro Plus',
];

const typeDocument = [
    { value: '1', text: 'Cédula' },
    { value: '2', text: 'Pasaporte' },
    { value: '3', text: 'Residencia' },
];

const economicActivity = [
    { value: '1', text: 'EMPLEADO' },
    { value: '3', text: 'PROPIETARIO DE NEGOCIO' },
    { value: '4', text: 'ESTUDIANTE' },
    { value: '5', text: 'AMA DE CASA' },
];

const gender = [
    { value: '1', text: 'Femenino' },
    { value: '2', text: 'Masculino' },
];

const civilStatus = [
    { value: '1', text: 'Casado(a)' },
    { value: '2', text: 'Soltero(a)' },
    { value: '3', text: 'Divorciado(a)' },
    { value: '4', text: 'Viudo(a)' },
    { value: '5', text: 'Union Libre' },
];

const vehicleStatus =[
    { value: '1', text: 'Nuevo' },
    { value: '0', text: 'Usado' }   
]


const txtAcceptTerm: string = "Lea estos términos y condiciones de uso cuidadosamente. al ingresar este sitio web y cualquiera de sus páginas, sean del mismo Grupo LAFISE, subsidiarias y/o afiliados, usted acuerda cumplir con los términos y condiciones abajo descritos. por el simple uso o acceso a cualquiera de las páginas que integran dicho portal, el usuario se sujeta o somete de manera tácita y expresa de manera plena y sin reservas de los presentes términos y condiciones de uso. si usted no está de acuerdo con los términos y condiciones abajo descritos, no ingrese a este sitio web. no todos los productos y servicios presentes están disponibles en todas las áreas geográficas. su elegibilidad para un producto y/o servicio en particular está sujeto a una determinación final por Grupo LAFISE, subsidiarias y/o sus afiliados.";


export { pagesTitleCat, pagesSubTitleCat, typeDocument, txtAcceptTerm,economicActivity,gender,civilStatus, vehicleStatus };